import { defineMessages } from "react-intl";

import { node as autoimmunLabProcedures } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures";
import { node as standardLabProcedures } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.lab_procedures",
		defaultMessage: "Laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "labProcedures",
	value: { type: "list", title: messages.title },
	children: [standardLabProcedures, autoimmunLabProcedures]
};
